/* Keep every embedded size chart independent, including modal content. */
(function () {
  'use strict';
  function updateChart(select) {
    var table = select.closest('table.size-chart');
    if (!table) return;
    table.querySelectorAll('[data-size-values]').forEach(function (cell) {
      try {
        var values = JSON.parse(cell.getAttribute('data-size-values'));
        if (Object.prototype.hasOwnProperty.call(values, select.value)) {
          cell.textContent = String(values[select.value]);
        }
      } catch (error) {
        // Preserve the existing value if a chart row has invalid data.
      }
    });
  }
  document.addEventListener('change', function (event) {
    if (event.target.matches('table.size-chart select.country-select')) {
      updateChart(event.target);
    }
  });
  document.querySelectorAll('table.size-chart select.country-select').forEach(updateChart);
})();
